<div class="check-list-wrapper">
  <div class="checklist-panel">

    <div class="header">
      <div class="title">{{ 'checklist.deliveryLearningChecklistSetup' | translate }}</div>
      <div class="warning-msg" *ngIf="allItemWithoutDuration">
        <div><span class="material-icons">info</span></div>
        <div>{{ 'checklist.pleaseAddDurationToAllChecklistItems' | translate }}</div>
      </div>
    </div>

    <section *ngIf="!(allChecklistLoading$ | async); else loader">
      <div class="panel-left" id="opCodesListSection">
        <form [formGroup]="checkListForm">
          <div formGroupName="allChecklistForm" class="list-checklist all-checklist">
            <div class="list-title">
              {{ 'checklist.allChecklistItems' | translate }} <span>({{(allChecklistCount$ | async)}})</span>
              <span class="primary-text-color expand-collapse"
                (click)="isAllChecklistExpandAll = !isAllChecklistExpandAll">
                {{ (isAllChecklistExpandAll ? 'checklist.collapseAll' : 'checklist.expandAll') | translate }}</span>
            </div>

            <div class="list-checklist-container">
              <div class="search-form">
                <mat-form-field class="example-full-width" appearance="outline">
                  <input type="text" autocomplete="off" formControlName="searchQuery" matInput
                    placeholder="{{ 'checklist.searchChecklistElements' | translate }}">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
              </div>

              <div class="all-checklist-sort-by mb-0 d-flex" [ngClass]="'sort-' + sortOrder">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'opcodeServiceManagement.show' | translate }}</mat-label>
                  <mat-select formControlName="sortBy">
                    <mat-option value="alpha">{{ 'opcodeServiceManagement.sortBy' | translate }} - {{
                      'opcodeServiceManagement.alphabetical' | translate }}</mat-option>
                    <mat-option value="duration">{{ 'opcodeServiceManagement.sortBy' | translate }} - {{
                      'servicePersonnel.duration' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <asp-icon [title]="sortOrder + 'ending'" name="sort-asc-desc.svg" width="1.5rem" height="1.5rem"
                  class="m-auto cursor-pointer" (click)=onAllSortOrderChange()></asp-icon>
              </div>

              <div id="all-checklist" class="checklist-list">

                <div *ngIf="getCategories(formattedAllChecklist).length">
                  <div *ngFor="let category of getCategories(formattedAllChecklist, true)">

                    <mat-expansion-panel *ngIf="formattedAllChecklist[category].length"
                      [expanded]="isAllChecklistExpandAll">

                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span class="category">{{ categoriesTranslation[category] | translate}}</span>
                          <span  class="warning-icon" *ngIf="!isAllHaveDuration(formattedAllChecklist[category])">
                            <span class="material-icons" [matTooltip]="'checklist.pleaseAddDurationToAllChecklistItems' | translate"
                    matTooltipClass="asp-custom-tooltip">info</span>
                          </span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <multi-drag-drop class="d-flex"
                        emptyText="{{ 'checklist.thereAreNoChecklistItemsToDisplay' | translate }}"
                        [items]="formattedAllChecklist[category]" [allowSort]="false"
                        [dragDisabled]="true"
                        (selectionChanged)="selectionChanged($event, 1, category)">
                        <ng-template let-item>
                          <app-checklist-item [item]="item"></app-checklist-item>
                        </ng-template>
                      </multi-drag-drop>
                    </mat-expansion-panel>
                  </div>
                </div>

                <div *ngIf="!getCategories(formattedAllChecklist).length">
                  {{ 'checklist.thereAreNoChecklistItemsToDisplay' | translate}}
                </div>

              </div>
            </div>
          </div>

          <div class="arrow-container">

            <span [ngClass]="selectedChecklistFromOnline.length > 0  ? '' : 'hide-content'"
              class="selection-text mb-2">{{ (selectedChecklistFromOnline.length) + ('opcodeServiceManagement.selected'
              | translate)}}</span>
            <asp-icon class="indicator-height mb-2" name="move-left.svg" color="inherit"
              [ngClass]="selectedChecklistFromOnline.length > 0 ? 'highlight' : ''"
              (click)="updateChecklistStatus(false)"></asp-icon>
              
            <asp-icon class="indicator-height inverse mb-2" name="move-left.svg" color="inherit"
              [ngClass]="selectedChecklistFromAll.length > 0 && isSelectedItemValid(selectedChecklistFromAll)  ? 'highlight' : 'no-update'"
              (click)="updateChecklistStatus(true)">
            </asp-icon>
            <span [ngClass]="selectedChecklistFromAll.length > 0 ? '' : 'hide-content'" class="selection-text">{{
              selectedChecklistFromAll.length + ('opcodeServiceManagement.selected' | translate)}}</span>
          </div>

          <div formGroupName="onlineChecklistForm" class="list-checklist online-checklist">
            <div class="list-title">
              {{ 'checklist.onlineChecklistItems' | translate}} <span>({{(onlineChecklistCount$ | async)}})</span>
              <span class="primary-text-color expand-collapse"
                (click)="isOnlineChecklistExpandAll = !isOnlineChecklistExpandAll">{{(isOnlineChecklistExpandAll ?
                'checklist.collapseAll' : 'checklist.expandAll') | translate }}</span>
            </div>

            <div class="list-checklist-container online-checklist-container">
              <div class="all-checklist-sort-by mt-0 d-flex">
                <mat-form-field appearance="outline">
                  <mat-label>{{'opcodeServiceManagement.show' | translate }}</mat-label>
                  <mat-select formControlName="show">
                    <mat-option value="all">{{'opcodeServiceManagement.all' | translate }}</mat-option>
                    <mat-option [value]='obj.id' *ngFor="let obj of categories">
                      {{ obj.display | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="all-checklist-sort-by mb-0 mt-0 d-flex" [ngClass]="'sort-' + onlineSortOrder">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'opcodeServiceManagement.onlineSorting' | translate }}</mat-label>
                  <mat-select formControlName="sortBy">
                    <mat-option value="alpha">{{ 'opcodeServiceManagement.alphabetical' | translate }}</mat-option>
                    <mat-option value="custom">{{ 'opcodeServiceManagement.custom' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <asp-icon [title]="onlineSortOrder + 'ending'" name="sort-asc-desc.svg" width="1.5rem" height="1.5rem"
                  class="m-auto cursor-pointer" (click)=onOnlineSortOrderChange()></asp-icon>
              </div>

              <div id="online-checklist" class="online-opcodes-list online-list">
                <div *ngIf="getCategories(formattedOnlineChecklist).length">
                  <div *ngFor="let category of getCategories(formattedOnlineChecklist, true, 'online')">

                    <mat-expansion-panel
                      *ngIf="(onlineShowChecklist === 'all' || onlineShowChecklist=== category) && formattedOnlineChecklist[category].length"
                      [expanded]="isOnlineChecklistExpandAll">

                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span class="category">{{categoriesTranslation[category] | translate}}</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <multi-drag-drop class="d-flex"
                        emptyText="{{ 'checklist.thereAreNoChecklistItemsToDisplay' | translate }}"
                        [items]="formattedOnlineChecklist[category]" 
                        (selectionChanged)="selectionChanged($event, 2, category)">
                        <ng-template let-item>
                          <app-checklist-item [item]="item"></app-checklist-item>
                        </ng-template>
                      </multi-drag-drop>
                    </mat-expansion-panel>
                  </div>
                </div>

                <div *ngIf="!getCategories(formattedOnlineChecklist).length">
                  {{ 'checklist.thereAreNoChecklistItemsToDisplay' | translate}}
                </div>

              </div>

            </div>
          </div>
        </form>
      </div>

      <div class="panel-right">
        <app-checklist-form [checklist]="selectedChecklist" [saveClicked]="saveClicked" (formEdited)="valuesChanged($event)">
        </app-checklist-form>
      </div>
    </section>
  </div>
</div>

<ng-template #loader>
  <div id="loading-spinner">
    <app-loading size="0.5" color="var(--primary-sec-color)"></app-loading>
  </div>
</ng-template>